import button from "./button.module.scss"

const Button = (props) => {
    const handleClick = (e) => {
        e.preventDefault();
        props.handleClick();
    }
    return(
        <button
            type="submit"
            className={[button.button, props.class, `${props.icon && button.withIcon}`].join(" ")}
            onClick= {handleClick}>
            {props.icon && (<div className={[button.icon, `${!props.title && button.onlyIcon}`].join(" ")}><img src={props.icon} alt=""/></div>)}
            {props.title || ""}
        </button>)
}

export default Button;